export const APP = {
  name: 'Distress Deal Market',
  brand: 'DDM',
  client: 'Luxarabia',
  city: 'Dubai',
  projectCode: 'PV-1052',
  // Official Luxarabia agency WhatsApp for generic site CTAs (footer, floating
  // button, contact, FAQ). International format, digits only. Advisor-specific
  // numbers stay on deal pages via pickAdvisorWhatsAppPhone — never here.
  whatsappNumber: '971586810389',
  // Public social URLs surfaced by the Footer "Follow" section. Null
  // entries hide their column entry; flip to a string when accounts ship.
  social: {
    instagram: null as string | null,
    linkedin: null as string | null,
  },
} as const;
